module.exports = __webpack_public_path__ + "img/2c.22b8ee1a.svg";